import React from "react";
import "../styles/Rajasthan.css";
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import rajasthanData from "../data/rajasthan.json";
import rajasthanBanner from "../assets/jaipur.webp";

const imageMap = {
  "../assets/jaipur1.png": require("../assets/jaipur1.png"),
  "../assets/udaipur.png": require("../assets/udaipur.png"),
  "../assets/jodhpur.png": require("../assets/jodhpur.png"),
  "../assets/jodhpur.png": require("../assets/jodhpur.png"),
  "../assets/jaisalmer.png": require("../assets/jaisalmer.png"),
  "../assets/pushkar.png": require("../assets/pushkar.png"),
  "../assets/mountabu.png": require("../assets/mountabu.png"),
  "../assets/bikaner.png": require("../assets/bikaner.png"),
  "../assets/ajmer.png": require("../assets/ajmer.png"),
  "../assets/bundi.png": require("../assets/bundi.png"),
  "../assets/chittorgarh.png": require("../assets/chittorgarh.png"),
  "../assets/amberfort.png": require("../assets/amberfort.png"),
  "../assets/mehrangarh.png": require("../assets/mehrangarh.png"),
  "../assets/jaisalmerfort.png": require("../assets/jaisalmerfort.png"),
  "../assets/chittorgarhfort.png": require("../assets/chittorgarhfort.png"),
  "../assets/kumbhalgarhfort.png": require("../assets/kumbhalgarhfort.png"),
  "../assets/junagarhfort.png": require("../assets/junagarhfort.png"),
  "../assets/ranthambore.png": require("../assets/ranthambore.png"),
  "../assets/lohagarh.png": require("../assets/lohagarh.png"),
  "../assets/nahargarh.png": require("../assets/nahargarh.png"),
  "../assets/taragarh.png": require("../assets/taragarh.png"),
  "../assets/folkdance.png": require("../assets/folkdance.png"),
  "../assets/puppetshow.png": require("../assets/puppetshow.png"),
  "../assets/camelsafari.png": require("../assets/camelsafari.png"),
  "../assets/festival.png": require("../assets/festival.png"),
  "../assets/mehndi.png": require("../assets/mehndi.png"),
  "../assets/rajasthan.png": require("../assets/rajasthan.png"),
  "../assets/folkmusic.png": require("../assets/folkmusic.png"),
  "../assets/turban.png": require("../assets/turban.png"),
  "../assets/blockprinting.png": require("../assets/blockprinting.png"),
  "../assets/camel.png": require("../assets/camel.png"),
  "../assets/tajudaipur.png": require("../assets/tajudaipur.png"),
  "../assets/umaid.png": require("../assets/umaid.png"),
  "../assets/rambagh.png": require("../assets/rambagh.png"),
  "../assets/leelaudaipur.png": require("../assets/leelaudaipur.png"),
  "../assets/suryagarh.png": require("../assets/suryagarh.png"),
  "../assets/alsisar.png": require("../assets/alsisar.png"),
  "../assets/deogarh.png": require("../assets/deogarh.png"),
  "../assets/narain.png": require("../assets/narain.png"),
  "../assets/shivniwas.png": require("../assets/shivniwas.png"),
  "../assets/rajpalace.png": require("../assets/rajpalace.png"),
  "../assets/johari.png": require("../assets/johari.png"),
  "../assets/bapubazar.png": require("../assets/bapubazar.png"),
  "../assets/sardarmarket.png": require("../assets/sardarmarket.png"),
  "../assets/clocktower.png": require("../assets/clocktower.png"),
  "../assets/hathipolbazar.png": require("../assets/hathipolbazar.png"),
  "../assets/tripolia.png": require("../assets/tripolia.png"),
  "../assets/naisarak.png": require("../assets/naisarak.png"),
  "../assets/badabazar.png": require("../assets/badabazar.png"),
};

const Rajasthan = () => {
  const location = useLocation();
  return (
    <>
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <a
              href="#"
              className={`contact-dropbtn ${
                location.pathname === "/rajasthan" ? "active-link" : ""
              }`}
            >
              Destinations
            </a>
            <div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
                              <Link to="/abu">Abu Dhabi</Link>
                <Link to="/dubai">Dubai</Link>
            </div>
          </div>
          <Link to="/hotels">Hotels</Link>
          <Link
            to="/contact-us"
            className={location.pathname === "/contact-us" ? "active-link" : ""}
          >
            Contact Us
          </Link>
        </nav>
        <Link to="/booknow">
          <button className="contact-book-btn">Book Now</button>
        </Link>
      </header>

      <div className="rajasthan-page">
        <div className="rajasthan-hero">
          <div className="rajasthan-hero-overlay">
            <h1>Explore Rajasthan</h1>
            <p>Palaces, Heritage, Culture – Your vibrant historical journey</p>
          </div>
          <img
            src={rajasthanBanner}
            alt="Goa Banner"
            className="goa-hero-img"
          />
        </div>

        <section className="rajasthan-info">
          <h2>Welcome to Rajasthan</h2>
          <p>
            Rajasthan is India's top destination for royal heritage, vibrant
            culture, and desert landscapes. With majestic forts, colorful
            cities, and rich traditions, it's perfect for historical immersion
            or thrilling adventures.
          </p>
        </section>

        {Object.entries(rajasthanData).map(([sectionTitle, items]) => (
          <section className="rajasthan-section" key={sectionTitle}>
            <h2>{formatTitle(sectionTitle)}</h2>
            <div className="rajasthan-cards-container">
              {items.map((item, index) => (
                <div className="rajasthan-card" key={index}>
                  <img
                    src={imageMap[item.image] || item.image}
                    alt={item.name}
                  />
                  <h3>{item.name}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case "Beaches":
      return "Beaches";
    case "Clubs":
      return "Clubs";
    case "Cafes":
      return "Cafes";
    case "Hotels":
      return "Hotels & Resorts";
    case "Forts":
      return "Forts";
    default:
      return key;
  }
};

export default Rajasthan;
